module.exports = __webpack_public_path__ + "static/media/ic_drop_down.e38f3038.svg";